import { render, staticRenderFns } from "./ServiceTypes.handler.vue?vue&type=template&id=666c3e3c&"
import script from "./ServiceTypes.handler.vue?vue&type=script&lang=ts&"
export * from "./ServiceTypes.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports